// extracted by mini-css-extract-plugin
export default {"mask-placeholder":"mask-placeholder__KcF0l","input":"input__vAqny","__hidden":"__hidden__S0sbJ"};